
import ProfileImg from '../atom/ProfileImg.vue';
import { getOperationTypeLabelKey } from '~/utils/constants/portfolioConstants';
export default {
  name: 'UITransactionPost',
  components: { ProfileImg },
  props: {
    transactionData: {
      type: Object,
      default: () => null,
      required: false,
    },
  },
  computed: {
    operationTypeLabel() {
      return this.$t(
        getOperationTypeLabelKey(this.transactionData?.operationType)
      );
    },
  },
};
